export class AppTypeStatusJurisdictionTimerConfig {
  id: number;
  applicationTypeStatusJurisdictionId: number;
  applicationStatusTimerConfigId: number;
  aggregateDurationAcrossStatusChanges: boolean;
}
